import { accountsActions, accountsSelectors } from 'app-components/flux/accounts';
import {
  preferencesActions as actions,
  preferencesSagas,
  preferencesSelectors,
  preferencesUtils,
} from 'app-components/flux/preferences';
import { fieldData, requiredColumns } from 'data/transactions/config.ts';
/*
 * PREFERENCE STORE SAGAS
 *
 * These routines listen for request actions, and satisfies them.  These are asynchronous routines, and upon
 * completion will dispatch a new action with the results
 *
 *
 */
import { List as ImmutableList } from 'immutable';
import { put, select, takeEvery } from 'redux-saga/effects';

// ====================================================
// INIT ACCOUNT PREFERENCES
export function* initAccountPreferences() {
  const accountsPending = yield select(accountsSelectors.getLoadPending);
  const prefsPending = yield select(preferencesSelectors.getLoadPendingState);
  if (!accountsPending && !prefsPending.shared.dataset) {
    const accounts = yield select(accountsSelectors.getAccountsById);
    const acctPrefs = yield select(preferencesSelectors.allAccountPreferences);

    if (accounts) {
      const newAcctPrefs = preferencesUtils.initAccountPrefs(accounts, acctPrefs);

      if (newAcctPrefs) {
        const prefObj = {
          section: 'shared',
          group: 'dataset',
          preference: { webApp: { accountsPrefs: newAcctPrefs } },
        };
        yield put(actions.setPreference(prefObj, { context: 'initAccountPreferences1' }));
      }
    }
    //
    // Also check if the transaction columns config was updated with new defaults
    // if the required defaults in the code contain any columns NOT in the registerPrefs, then
    // add required defaults in
    //
    const prefs = yield select(preferencesSelectors.getSharedPreferencesByPath, { group: 'dataset', path: ['webApp'] });

    const buildRegFields = (regFields, regFieldsDefault) => {
      let newRegFields = regFields || ImmutableList();
      regFieldsDefault?.forEach((col) => {
        if (!newRegFields.includes(col)) {
          const columnPosition = fieldData[col]?.position;
          const slot = newRegFields.findIndex((x) => fieldData[x]?.position > columnPosition);
          newRegFields = newRegFields.insert(slot, col);
        }
      });
      return newRegFields;
    };
    const regFieldsCashFlow = prefs.transactionRegister.regFieldsSort.cashFlow;
    const newFieldsCashFlow = buildRegFields(regFieldsCashFlow, requiredColumns.default);
    const regFieldsInvestment = prefs.transactionRegister.regFieldsSort.investment;
    const newRegFieldsInvestment = buildRegFields(regFieldsInvestment, requiredColumns.investment);
    if (newFieldsCashFlow !== regFieldsCashFlow || newRegFieldsInvestment !== regFieldsInvestment) {
      const prefObj = {
        section: 'shared',
        group: 'dataset',
        preference: {
          webApp: {
            transactionRegister: {
              regFieldsSort: {
                cashFlow: newFieldsCashFlow,
                investment: newRegFieldsInvestment,
              },
            },
          },
        },
      };
      yield put(actions.setPreference(prefObj, { context: 'initAccountPreferences2' }));
    }
  }
}

export function* getAccountsSuccessActionWatcher() {
  yield takeEvery(accountsActions.getAccountsSuccess, initAccountPreferences);
}

export function* upsertAccountsSuccessActionWatcher() {
  yield takeEvery(accountsActions.batchAccountsSuccess, initAccountPreferences);
}

export function* getPreferencesSuccessActionWatcher() {
  yield takeEvery(actions.getPreferencesSuccess, initAccountPreferences);
}

// ====================================================
// EXPORTS

export default [
  ...preferencesSagas,
  getAccountsSuccessActionWatcher,
  getPreferencesSuccessActionWatcher,
  upsertAccountsSuccessActionWatcher,
];
